<div class="center session-expire">
    <h3>Your session has expired. <a href="javascript: window.open('about:blank','_self','').close();">Click here </a> to close this window</h3>
</div>
